import { Modal, Button, ButtonGroup, ToggleButton } from "react-bootstrap";
import React from 'react';
import './Estilos.style.scss'
import Footer from './Footer';
import Header from './Header';
import ListItem from './List/ListItem';
import PESO_IMG from '../images/peso.png';
import PERRO_IMG from '../images/perro.png';
import COMIDA_IMG from '../images/comida.png';
import HC_IMG from '../images/hueso_carnoso.png';
import CM_IMG from '../images/carne_magra.png';
import PULMON_IMG from '../images/pulmon.png';
import FRUTA_IMG from '../images/fruta.png';
import CESTA_IMG from '../images/cesta.png';
import ListaCompra from "./ListaCompra";

const radios = [
    { name: 'Si', value: '1' },
    { name: 'No', value: '2' },
];
const cachorroMiniValues = [
    { name: 'Si', value: '1' },
    { name: 'No', value: '2' },
];
const TipoActividadPerro = [
    { name: 'Normal', value: '1' },
    { name: 'Moderada', value: '2' },
    { name: 'Intensa', value: '3' },
];
const TipoGalgo = [
    { name: 'Si', value: '1' },
    { name: 'No', value: '2' },
];
const TipoToy = [
    { name: 'Si', value: '1' },
    { name: 'No', value: '2' },
];

class Calculator extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            dog_tipe: 2,
            gramos: 0,
            peso: 12,
            hc: 0,
            cm: 0,
            visible: true,
            esCachorro: 0,
            edad_cachorro: 1,
            esCachorroMini: 0,
            esGalgo: 0,
            actividad_perro: 0,
            es_toy: 0,
            vi: 0,
            fv: 0,
            nombre_perro: "",
            mostrar_perros: false,
            listaCompraVisible: false,
        }
    }
    componentDidMount() {
        this._calcularBarf(this.state.peso, this.state.dog_tipe)

    }
    reiniciarPreguntas() {
        this.setState({
            esCachorro: 0,
            edad_cachorro: 1,
            esCachorroMini: 0,
            esGalgo: 0,
            actividad_perro: 0,
            es_toy: 0,
        })
    }
    handleEvent = (event) => {
        if (!isNaN(event.target.value)) {
            if (event.target.value < 11) {
                this.setState({
                    dog_tipe: event.target.value,
                })
                //Calculamos la barf correspondiente
                this._calcularBarf(this.state.peso, event.target.value)
            }
        }
    }
    capturarPeso = (event) => {
        if (!isNaN(event.target.value)) {
            this.setState({
                peso: event.target.value,
            })
            //Calculamos la barf correspondiente
            this._calcularBarf(event.target.value, this.state.dog_tipe)
        }
    }
    _calcularBarf(peso, complexion) {
        let cantidad_gramos = peso * complexion / 100 * 1000;
        let cantidad_hueso = 0.6;
        let cantidad_carne = 0.2;
        let cantidad_viscera = 0.1;
        let cantidad_fruta_verdura = 0.1;
        let hc = cantidad_gramos * cantidad_hueso;
        let cm = cantidad_gramos * cantidad_carne;
        let vi = cantidad_gramos * cantidad_viscera;
        let fv = cantidad_gramos * cantidad_fruta_verdura;
        this.setState({
            gramos: cantidad_gramos,
            hc: hc,
            cm: cm,
            vi: vi,
            fv: fv,

        });
    }
    _nombrePerro = (event) => {
        this.setState({ nombre_perro: event.target.value })
    }
    _guardarPerro(nombre) {

        if (nombre) {
            let perro = {
                nombre: nombre,
                peso: this.state.peso,
                porcentaje: this.state.dog_tipe
            }
            // obtenemos los perros
            let perros = localStorage.getItem("PERROS")
            let perrosObjeto = JSON.parse(perros);
            if (!perrosObjeto) {
                perrosObjeto = []
            }
            perrosObjeto.push(perro);

            this._guardarStorage("PERROS", JSON.stringify(perrosObjeto))
        }
    }
    _showPerros = () => {
        this.setState({
            mostrar_perros: true
        });
    }
    _hidePerros = () => {
        this.setState({
            mostrar_perros: false
        });
    }
    _guardarStorage(key, value) {
        localStorage.setItem(key, value)
    }
    renderPerros() {
        let perros = localStorage.getItem("PERROS");
        let perrosObjeto = JSON.parse(perros);
        let s = []
        if (perrosObjeto)
            perrosObjeto.forEach(element => {
                s.push(
                    <div style={{ display: 'block' }}><p style={{ display: 'inline-block', width: '70%' }}>{element.nombre}</p><a style={{ color: 'pink' }}>borrar</a></div>
                )
            });
        return s;
    }

    openModal() {
        this.setState({
            visible: true
        });
    }

    handleClose() {
        this.setState({
            visible: false
        });
    }
    _calculoRacionCachorro() {
        //TODO meter validaciones funciones Comprobar que tenemos todos lo dastos
        if (this.state.esCachorroMini === 0) {
            alert("Rellene todos los campos")
        } else {
            //FIXME no se ha seleccionado nada
            if (this.state.edad_cachorro === 1) {
                this._setPorcentaje(10);
            } else {
                switch (this.state.edad_cachorro) {
                    case "1" || "2": this._setPorcentaje(10);
                        break;
                    case "3" || "4": this._setPorcentaje(8);
                        break;
                    case "5" || "6": this._setPorcentaje(6);
                        break;
                    case "7" || "8": this._setPorcentaje(4);
                        break;
                    case "9" || "10": this._setPorcentaje(3);
                        break;
                    case "11": this._setPorcentaje(3);
                        break;
                    case "12": this._setPorcentaje(2);
                        break;

                }
            }
        }

    }
    _validarAdulto() {

        let result = this.state.esGalgo || 0 && this.state.es_toy !== 0 && this.state.actividad_perro !== 0;
        if (!result) {
            alert("Rellene todos los campos");
        }
        return result;
    }
    _calculoRacionAdulto() {
        if (this._validarAdulto()) {
            if (this.state.esGalgo === "1") {
                this._setPorcentaje(4);
            }
            else if (this.state.es_toy === "1") {
                this._setPorcentaje(4.5);
            }
            else {
                switch (this.state.actividad_perro) {
                    case "1": this._setPorcentaje(2);
                        break;
                    case "2": this._setPorcentaje(2.5);
                        break;
                    case "3": this._setPorcentaje(3);
                        break;
                }
            }
        }
    }
    closeSaveCalculate() {
        // primero comprobamos si es cachorro
        if (this.state.esCachorro === "1") {
            // El caso de que sea cachorro comprobamos la eda
            this._calculoRacionCachorro()

        } else {
            this._calculoRacionAdulto()
        }


    }
    _setPorcentaje(value) {
        let valor_final = value;
        if (value < 6 && this.state.esCachorroMini === "1") {
            valor_final = 5;
        }
        this.setState({
            dog_tipe: valor_final,
            visible: false
        })
        this._calcularBarf(this.state.peso, valor_final);

    }
    setRadioValue(value) {
        if (value !== this.state.esCachorro) {
            this.reiniciarPreguntas();
        }
        this.setState({
            esCachorro: value
        });
    }
    setEdadCachorro = (event) => {
        if (!isNaN(event.target.value)) {
            this.setState({
                edad_cachorro: event.target.value,
            })

        }
    }
    setEsCachorroMini(value) {
        this.setState({
            esCachorroMini: value
        });
    }
    setEsGalgo(value) {
        this.setState({
            esGalgo: value
        });
    }
    setActividad(value) {
        this.setState({
            actividad_perro: value
        });
    }
    setEsToy(value) {
        this.setState({
            es_toy: value
        });
    }
    abrirModal() {
        this.setState({
            visible: true
        });
    }
    _mostrarListaCompra(value) {
        this.setState({
            listaCompraVisible: value
        })
    }
    render() {

        return (
            <div style={{ display: 'flex', flexDirection: 'column', flex: 1, backgroundColor: 'white', paddingBottom: '80px' }}>

                <Header onClick={() => this.abrirModal()} />
                <div style={{ backgroundColor: '#561574' }} class="container">
                    <Modal show={this.state.visible} onHide={() => this.handleClose()}>
                        <Modal.Header closeButton>
                            <Modal.Title>Antes de empezar</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            Para poder hacer un cálculo más exacto de las proporciones responde a las siguientes preguntas
                            <hr />
                            <div class="row">
                                <div class="col">
                                    <h6>Peso</h6>
                                </div>
                                <div class="col">
                                    <h6>{this.state.peso} kg</h6>
                                </div>
                            </div>
                            <input value={this.state.peso} onChange={this.capturarPeso} type="range" class="form-range edad" id="customRange1" min="1" max="60" />

                            <div>
                                <h6>¿Es cachorro?</h6>
                                <ButtonGroup>
                                    {radios.map((radio, idx) => (
                                        <ToggleButton
                                            key={idx}
                                            id={`radioescachorro-${idx}`}
                                            type="radio"
                                            variant={'outline-success'}
                                            name="radio"
                                            value={radio.value}
                                            checked={this.state.esCachorro === radio.value}
                                            onChange={(e) => this.setRadioValue(e.currentTarget.value)}
                                        >
                                            {radio.name}
                                        </ToggleButton>
                                    ))}
                                </ButtonGroup>
                            </div>
                            {(this.state.esCachorro === "1") ?
                                <div>
                                    <div class="marginTop">
                                        <div class="row">
                                            <div class="col">
                                                <h6>Edad</h6>
                                            </div>
                                            <div class="col">
                                                <h6>{this.state.edad_cachorro} meses</h6>
                                            </div>
                                        </div>
                                        <input value={this.state.edad_cachorro} onChange={this.setEdadCachorro} type="range" class="form-range edad" id="customRange1" min="1" max="12" />

                                    </div>
                                    <div>
                                        <div class="marginTop">
                                            <h6>¿Es Raza mini?</h6>
                                            <ButtonGroup>
                                                {cachorroMiniValues.map((radio, idx) => (
                                                    <ToggleButton
                                                        key={idx}
                                                        id={`radiocachorromini-${idx}`}
                                                        type="radio"
                                                        variant={'outline-success'}
                                                        name="radioe"
                                                        value={radio.value}
                                                        checked={this.state.esCachorroMini === radio.value}
                                                        onChange={(e) => this.setEsCachorroMini(e.currentTarget.value)}
                                                    >
                                                        {radio.name}
                                                    </ToggleButton>
                                                ))}
                                            </ButtonGroup>
                                        </div>
                                    </div>
                                </div>
                                :
                                (this.state.esCachorro === "2") &&
                                <div>
                                    <div class="marginTop">
                                        <h6>¿Es un galgo o un perro de trabajo?</h6>
                                        <ButtonGroup>
                                            {TipoGalgo.map((radio, idx) => (
                                                <ToggleButton
                                                    key={idx}
                                                    id={`radiogalgo-${idx}`}
                                                    type="radio"
                                                    variant={'outline-success'}
                                                    name="radiogalgo"
                                                    value={radio.value}
                                                    checked={this.state.esGalgo === radio.value}
                                                    onChange={(e) => this.setEsGalgo(e.currentTarget.value)}
                                                >
                                                    {radio.name}
                                                </ToggleButton>
                                            ))}
                                        </ButtonGroup>
                                    </div>
                                    {(this.state.esGalgo === "2") &&
                                        <div>
                                            <div class="marginTop">
                                                <h6>¿cuanta actividad realiza tu perro?</h6>
                                                <ButtonGroup>
                                                    {TipoActividadPerro.map((radio, idx) => (
                                                        <ToggleButton
                                                            key={idx}
                                                            id={`radioactividad-${idx}`}
                                                            type="radio"
                                                            variant={'outline-success'}
                                                            name="radioactividad"
                                                            value={radio.value}
                                                            checked={this.state.actividad_perro === radio.value}
                                                            onChange={(e) => this.setActividad(e.currentTarget.value)}
                                                        >
                                                            {radio.name}
                                                        </ToggleButton>
                                                    ))}
                                                </ButtonGroup>
                                            </div>
                                            <div class="marginTop">
                                                <h6>¿Es raza toy/mini?</h6>
                                                <ButtonGroup>
                                                    {TipoToy.map((radio, idx) => (
                                                        <ToggleButton
                                                            key={idx}
                                                            id={`radiotoy-${idx}`}
                                                            type="radio"
                                                            variant={'outline-success'}
                                                            name="radiotoy"
                                                            value={radio.value}
                                                            checked={this.state.es_toy === radio.value}
                                                            onChange={(e) => this.setEsToy(e.currentTarget.value)}
                                                        >
                                                            {radio.name}
                                                        </ToggleButton>
                                                    ))}
                                                </ButtonGroup>
                                            </div>
                                        </div>
                                    }

                                </div>
                            }

                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={() => this.handleClose()}>
                                saltar
                            </Button>
                            <Button variant="primary" onClick={() => this.closeSaveCalculate()}>
                                Calcular
                            </Button>
                        </Modal.Footer>
                    </Modal>
                    <ListaCompra
                        total={this.state.gramos}
                        hueso_carnoso={this.state.hc}
                        carne={this.state.cm}
                        viscera={this.state.vi}
                        fruta_verdura={this.state.fv}
                        visible={this.state.listaCompraVisible} ListaVisible={(value) => this._mostrarListaCompra(value)} />
                    <div class="row">
                        <div class="col text-center">
                            <div class="col text-center">
                                <div class="row text-center">
                                    <div class="col  align-middle">
                                        <img className="inconCenter" src={PESO_IMG} alt="Logo" />
                                        <label for="customRange1" class="form-label text-light text-small">Peso perro</label>
                                    </div>
                                    <div class="col ">
                                        <div for="customRange1" class="texto-centrado">{this.state.peso} kg</div>
                                    </div>

                                </div>
                                <input value={this.state.peso} onChange={this.capturarPeso} type="range" class="form-range slider-principal" id="customRange1" min="1" max="60" />
                            </div>
                        </div>
                        <div class="col text-center">

                            <div class="row text-center">
                                <div class="col  align-middle">
                                    <img className="inconCenter" src={PERRO_IMG} alt="Logo" />
                                    <label for="customRange1" class="form-label text-light text-small">porcentaje</label>
                                </div>
                                <div class="col ">
                                    <div for="customRange1" class="texto-centrado">{this.state.dog_tipe} %</div>
                                </div>

                            </div>
                            <input value={this.state.dog_tipe} onChange={this.handleEvent} type="range" class="form-range slider-principal" id="customRange1" min="2" max="10" step="0.5" />
                        </div>

                    </div>
                </div>

                <div class="container ">
                    <div class="container-fluid justify-content-center">
                        <ListItem image={COMIDA_IMG} name={'Gramos Totales'} value={this.state.gramos} />
                    </div>
                    <div class="row">
                        <div class="col">
                            <ListItem image={HC_IMG} name={'Hueso carnoso'} value={this.state.hc} />
                        </div>
                        <div class="col">
                            <ListItem image={CM_IMG} name={'Carne Magra'} value={this.state.cm} />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <ListItem image={PULMON_IMG} name={'Viscera'} value={this.state.vi} />
                        </div>
                        <div class="col">
                            <ListItem image={FRUTA_IMG} name={'Fruta verdura'} value={this.state.fv} />
                        </div>
                    </div>

                </div>
                <div class="container ">
                    <div className="BottomText">
                        <p class="h6" style={{ fontSize: "10px" }}>Bienvenido a nuestra calculadora, una herramienta que te permite de forma rápida consultar la ración de tu perro si quieres más información sobre la dieta barf pincha <a href="https://extraperrestres.com/barf/">aqui</a></p>
                    </div>
                </div>
                <Footer>

                    <div class="container" className="BottonCompra">
                        <a className="linkBoton" onClick={() => this._mostrarListaCompra(true)}>
                            <img style={{ width: "20px", marginRight: "6px", paddingBottom: "4px" }} src={CESTA_IMG} alt="Logo" />
                            Calcular compra
                        </a>
                    </div>
                </Footer>

            </div>
        )
    }
}
export default Calculator;